module.exports = __webpack_public_path__ + "static/media/email.3a01c969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/contact-by/email.svg
// module id = 657
// module chunks = 0